import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title: string;
  color?: "primary" | "secondary" | "warning" | "success" | "error" | "info";
  count?: number;
  action?: ReactNode;
};

export const SectionHeader = ({
  icon,
  title,
  color = "primary",
  count,
  action,
}: Props) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    spacing={1}
  >
    <Stack direction="row" alignItems="center" spacing={1.25}>
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: (theme) => alpha(theme.palette[color].main, 0.1),
        }}
      >
        {icon}
      </Box>
      <Typography variant="subtitle1" fontWeight={700}>
        {title}
      </Typography>
    </Stack>

    <Stack direction="row" alignItems="center" spacing={1}>
      {typeof count === "number" && count > 0 && (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1.25,
            py: 0.5,
            borderRadius: 999,
            backgroundColor: (theme) => alpha(theme.palette[color].main, 0.12),
            border: "1px solid",
            borderColor: (theme) => alpha(theme.palette[color].main, 0.3),
            color: `${color}.main`,
          }}
        >
          <Typography variant="caption" fontWeight={700} lineHeight={1.4}>
            {count}
          </Typography>
        </Box>
      )}
      {action}
    </Stack>
  </Stack>
);
